import { render, staticRenderFns } from "./ofsCatalog.vue?vue&type=template&id=066f7485&scoped=true&"
import script from "./ofsCatalog.vue?vue&type=script&lang=js&"
export * from "./ofsCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ofsCatalog.vue?vue&type=style&index=0&id=066f7485&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f7485",
  null
  
)

export default component.exports